<template>
  <div
    :class="{ 'g-content': !(detail && !hasReadPermissioin), docs: detail && hasReadPermissioin }"
  >
    <div class="docs-header" v-if="detail && hasReadPermissioin">
      <div class="docs-header-content">
        <h3>
          <span v-if="detail && detail.title"
            >{{ detail.title
            }}<i>{{ $t('docs_category_title') }}：{{ detail.wikiCategoryName }}</i></span
          >
        </h3>
        <DocsOperation
          :record="detail"
          :popover="false"
          :toggle="{
            back: true,
            edit: false,
            delete: true,
            enable: true,
            disable: true,
            props: true,
            share: true,
          }"
          :isDetail="true"
          @callback="getDetail"
        />
      </div>
    </div>

    <Loading v-if="loading" />
    <div v-else-if="detail" class="docs-detail-content">
      <div v-if="hasReadPermissioin" class="docs-detail">
        <div class="docs-detail-left">
          <div class="docs-detail-title">{{ $t('docs_detail_base_info') }}</div>
          <div class="docs-detail-content">
            <div class="docs-detail-img">
              <!-- <img :src="`${avatarUrl}`" v-if="avatarUrl" style="width:100%;height:100%" /> -->
              <Icon type="docs-icon" />
            </div>
            <div class="docs-detail-base">
              <ul>
                <li>
                  <label>{{ $t('docs_detail_base_status') }}:</label>
                  <p>
                    <DocStatus :status="detail.enable" />
                  </p>
                </li>
                <li>
                  <label>{{ $t('docs_detail_base_createBy') }}:</label>
                  <p>{{ detail.createBy }}</p>
                </li>
                <li>
                  <label>{{ $t('docs_detail_base_createTime') }}:</label>
                  <p>
                    {{ detail.createTime | formatDate }}
                  </p>
                </li>
                <li>
                  <label>{{ $t('docs_detail_base_updateBy') }}:</label>
                  <p>{{ detail.updateBy }}</p>
                </li>
                <li>
                  <label>{{ $t('docs_detail_base_updateTime') }}:</label>
                  <p>
                    {{ detail.updateTime | formatDate }}
                  </p>
                </li>
                <li style="margin-bottom: 0px;" v-if="isSuperAdmin">
                  <label>{{ $t('docs_form_type') }}:</label>
                  <p>
                    <span>{{ detail.type }}</span>
                  </p>
                </li>
                <li v-if="isSuperAdmin">
                  <label></label>
                  <p style="color:#999;font-size:12px;">{{ $t('docs_form_type_help') }}</p>
                </li>
                <li>
                  <label>{{ $t('docs_detail_base_description') }}:</label>
                  <p>
                    {{ detail.intro || '--' }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="docs-detail-right">
          <div class="docs-detail-path">
            <div class="docs-detail-title">{{ $t('docs_detail_path') }}</div>
            <div class="docs-detail-content">
              <a-input-search
                size="large"
                @search="
                  () => {
                    // 复制
                    copyContent(`#documentationURL`);
                  }
                "
                :value="url"
                readOnly
              >
                <a-button
                  slot="enterButton"
                  type="primary"
                  :data-clipboard-text="url"
                  id="documentationURL"
                  data-clipboard-action="copy"
                  size="large"
                >
                  {{ $t('com_btn_copy') }}
                </a-button>
              </a-input-search>
            </div>
          </div>
          <div class="docs-detail-auth">
            <div class="docs-detail-title">{{ $t('docs_form_auth') }}</div>
            <div class="docs-detail-content">
              <p>
                {{ $t('docs_form_auth_read') }}:
                <span>{{ detail?.readLevel }}</span>
              </p>
              <p>
                {{ $t('docs_form_auth_write') }}:
                <span>{{ detail?.writeLevel }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <NoAuth goback v-else />
    </div>
    <Empty v-else />
  </div>
</template>
<script>
import DocStatus from '@/views/docs/components/DocStatus';
import DocsOperation from '@/views/docs/components/Operation';
import * as DocsAPI from '@/api/docs';
import { copyContent } from '@/libs/utils';
import { hasReadWritePermission } from '@/libs/permissions';
import { mapState } from 'vuex';
// import { generateSignedUrl } from '@/config/oss';

export default {
  components: {
    DocStatus,
    DocsOperation,
  },
  name: 'Docs',
  data() {
    return {
      copyContent,
      id: null,
      detail: null,
      avatarUrl: null,
      loading: true,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getDetail();
  },
  computed: {
    ...mapState(['isSuperAdmin']),

    // 是否有数据编辑（包括删除、禁用等）权限
    hasReadPermissioin() {
      return hasReadWritePermission('read', 'wiki', this.detail.readLevel);
    },

    url() {
      return `${window.location.origin}/manage/docs/detail/${this.id}`;
    },
  },

  methods: {
    // 获取文档详情
    getDetail() {
      return DocsAPI.getDocumentDetail({ id: this.id })
        .then(async res => {
          if (res.code === 0 && res.data) {
            this.detail = res.data;

            // if (this.detail && this.detail.icons && this.detail.icons.length > 0) {
            //   this.avatarUrl = await generateSignedUrl({objectKey:this.detail.icons[0]});
            // }
          }
        })
        .catch(() => {
          this.list = null;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.docs {
  height: 100%;
  background: @g-layout-background;
  .docs-header {
    padding-bottom: 16px;
    background: @g-layout-background;
    .docs-header-content {
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px;
      border-radius: 12px;
    }
    h3 {
      margin: 0;
      display: flex;

      span {
        color: #18181a;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
      }

      i {
        display: block;
        font-style: normal;
        font-size: 14px;
        color: #999;
        font-weight: normal;
        padding-top: 10px;
      }
    }
  }
  .docs-detail-content {
    border-radius: 12px;

    .docs-detail {
      border-radius: 12px;
      display: flex;
      flex: 1;
      gap: 16px;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: stretch;

      .docs-detail-left {
        display: flex;
        padding: 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
        border-radius: 12px;
        background: #fff;
        width: 60%;
      }

      .docs-detail-right {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 40%;
      }

      .docs-detail-path {
        display: flex;
        padding: 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
        background: #fff;
        border-radius: 12px;
      }

      .docs-detail-auth {
        display: flex;
        padding: 24px;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
        background: #fff;
        border-radius: 12px;

        .docs-detail-content {
          display: flex;
          gap: 16px;
          align-items: center;
          justify-content: center;

          p {
            color: #18181a;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;

            span {
              color: #1838d9;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
            }
          }
        }
      }

      .docs-detail-title {
        color: rgba(0, 0, 0, 0.88);
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;

        span {
          color: #1838d9;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
        }
      }

      .docs-detail-content {
        display: flex;
        gap: 16px;
        width: 100%;
        justify-content: space-between;
        align-items: stretch;

        .docs-detail-img {
          border-radius: 12px;
          width: 30%;
          display: flex;
          align-items: center;
          justify-content: center;

          img,
          svg {
            width: 60%;
            height: 60%;
          }
        }
        .docs-detail-base {
          border-radius: 12px;
          width: 70%;
          ul {
            margin: 0;
            padding: 0;
            li {
              margin: 0;
              padding: 0;
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              margin-bottom: 16px;
              gap: 16px;

              label {
                color: #a0a0a7;
                text-align: right;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                width: 20%;
              }

              p {
                margin: 0;
                padding: 0;
                color: #18181a;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                flex: 1;
                padding-right: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
